import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { OrderHeadGet } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-order-picks',
    templateUrl: './order-head-order-picks.component.html',
    styleUrls: ['./order-head-order-picks.component.css'],
})
export class OrderHeadOrderPicksComponent implements OnChanges {
    @Input()
    public get?: OrderHeadGet;

    public orderPicksGrid?: GridOptions;

    public orderPicksAddedGrid?: GridOptions;

    public orderPicksCompletedGrid?: GridOptions;

    constructor(private modal: ModalService) {}

    public onTabChanged() {
        if (!this.get) return;

        if (this.get.gb_orderhead_main_orderpicks_status === 'NOT_ADDED') {
            this.readOrderPicksGrid();
        } else if (this.get.gb_orderhead_main_orderpicks_status === 'ADDED') {
            this.readOrderPicksAddedGrid();
        } else if (this.get.gb_orderhead_main_orderpicks_status === 'COMPLETEDPICKS') {
            this.readOrderPicksCompletedGrid();
        }
    }

    public readOrderPicksGrid() {
        if (!this.get) return;

        if (!this.orderPicksGrid) {
            this.orderPicksGrid = new Grid()
                .setRememberId('w_orderhead_orderpicks_grid')
                .setLoadDataFunction({ method: 3709, parameters: () => ({ order_internal_no: this.get?.order_internal_no, gb_orderhead_main_orderpicks_status: 'NOT_ADDED' }) })
                .addRowButton({ name: 'see_picked', icon: 'fas fa-eye', tooltip: 'open_orderpickview', translateTooltip: true, func: (row) => this.modal.openStateDialog({ state: 'orderpickview', params: `${row['orderpick_keyno']}` }) });
        } else {
            this.orderPicksGrid.gridfunc?.read();
        }
    }

    public readOrderPicksAddedGrid() {
        if (!this.get) return;

        if (!this.orderPicksAddedGrid) {
            this.orderPicksAddedGrid = new Grid().setRememberId('w_orderhead_orderpicks_grid_added').setLoadDataFunction({ method: 3709, parameters: () => ({ order_internal_no: this.get?.order_internal_no, gb_orderhead_main_orderpicks_status: 'ADDED' }) });
        } else {
            this.orderPicksAddedGrid.gridfunc?.read();
        }
    }

    public readOrderPicksCompletedGrid() {
        if (!this.get) return;

        if (!this.orderPicksCompletedGrid) {
            this.orderPicksCompletedGrid = new Grid().setRememberId('w_orderhead_orderpicks_grid_completedpicks').setLoadDataFunction({ method: 3709, parameters: () => ({ order_internal_no: this.get?.order_internal_no, gb_orderhead_main_orderpicks_status: 'COMPLETEDPICKS' }) });
        } else {
            this.orderPicksCompletedGrid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['get']) {
            this.onTabChanged();
        }
    }
}
